import { queryOptions } from '@tanstack/react-query';
import type {
  GetValorantPlayerData,
  GetValorantPlayerResponse,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';
import type { ReplacePathParams } from '@/shared/utils/pathParams';

export interface ValorantPlayerKeyParams {
  puuid: string;
}

export const getValorantPlayerKey = (params: ValorantPlayerKeyParams) => [
  'valorant',
  'players',
  params.puuid,
];

const getValorantPlayerUrl = (
  puuid: string | number,
): ReplacePathParams<GetValorantPlayerData['url']> =>
  `valorant/players/${puuid.toString()}`;

export const getValorantPlayerOptions = <T = GetValorantPlayerResponse>(
  params: ValorantPlayerKeyParams,
) => {
  const puuid = params.puuid;

  return queryOptions<GetValorantPlayerResponse, unknown, T>({
    queryKey: getValorantPlayerKey(params),
    queryFn: () =>
      PrivateApi.get(
        getValorantPlayerUrl(puuid),
      ).json<GetValorantPlayerResponse>(),
  });
};
